import { gql } from 'apollo-angular';

export const USERS_OVERVIEW = gql`
    query usersOverview {
        usersOverview {
            totalRegistered
            totalVerified
            totalUnVerified
            rideHailingTwoWheelsCount
            rideHailingFourWheelsCount
            expressTwoWheelsCount
            expressFourWheelsCount
        }
    }
`;

export const USERS_LIST = gql`
    query users($page: Int, $querySearch: String, $sortBy: UserSortingInput) {
        users(page: $page, querySearch: $querySearch, sortBy: $sortBy) {
            userId
            userReferrer
            membershipId
            name
            email
            mobile
            photo
            isVerify
            dateCreated
            dateUpdated
            currentPoints
            usedPoints
            totalPoints
        }
    }
`;

export const USER_BOOKING_EXPRESS_TRANS = gql`
    query bookingExpressTxns($userId:UserHashedId, $sortBy:BookingExpressSortingInput) {
        bookingExpressTxns(userId:$userId, sortBy:$sortBy) {
            bookingExpressId
            status
            notes
            dateCreated
            startFormattedAddress
            endFormattedAddress
            partnerRating {
                rate
            }
            user {
                dateCreated
                email
                isVerify
                membershipId
                mobile
                name
                currentPoints
                usedPoints
                userId
            }
            partner {
                partnerId
                tier
                membershipId
                firstName
                middleName
                lastName
                mobile
                email
                distributionArea
                vehicleType
                licensePlate
                isOtpVerify
                isApprove
                dateCreated
                currentPoints
                usedPoints
            }
            totalPrice
            orderRoutes
            totalDistance
            discountPrice
            farePrice
        }
    }
`;

export const USER_BOOKING_RIDE_TRANS = gql`
    query bookingRideTxns($userId:UserHashedId, $service:BookingRideServiceFilterInput!, $sortBy:BookingRideSortingInput) {
        bookingRideTxns(userId:$userId, service:$service, sortBy:$sortBy) {
            bookingRideId
            status
            dateCreated
            startFormattedAddress
            endFormattedAddress
            rating {
                rate
            }
            user {
                dateCreated
                email
                isVerify
                membershipId
                mobile
                name
                currentPoints
                usedPoints
                userId
            }
            partner {
                partnerId
                tier
                membershipId
                firstName
                middleName
                lastName
                mobile
                email
                distributionArea
                vehicleType
                licensePlate
                isOtpVerify
                isApprove
                dateCreated
                currentPoints
                usedPoints
            }
            totalPrice
            routes
            kmDistance
            discountPrice
            farePrice
        }
    }
`;
